module.exports = __webpack_public_path__ + "img/logocoto1.7d5e217a.svg";